export enum EnumDepartment {
  ADMIN = 'admin', // Administrativo
  TECH = 'tech', // Suporte técnico / Infraestrutura
  MKT = 'mkt', // Marketing
  SALES = 'sales', // Vendas
  FINANCE = 'finance', // Financeiro / Contábil
  LEGAL = 'legal', // Jurídico
  HR = 'hr', // Recursos Humanos
  LOGISTICS = 'logistics', // Logística / Frota
  SUPPORT = 'support', // Atendimento / Call Center
  POS_SALES = 'pos_sales', // Pós-venda
  TRAINING = 'training', // Treinamento / Ensino
  IT = 'it', // Desenvolvimento / Sistemas
  PROCUREMENT = 'procurement', // Compras
  MAINTENANCE = 'maintenance', // Oficina / Manutenção
  OPERATIONS = 'operations', // Operações gerais
  WAREHOUSE = 'warehouse', // Almoxarifado / Depósito
  OTHER = 'other', // Outros setores
}

export const DEPARTMENT_LABELS: Record<EnumDepartment, string> = {
  [EnumDepartment.ADMIN]: 'Administrativo',
  [EnumDepartment.TECH]: 'Técnico',
  [EnumDepartment.MKT]: 'Marketing',
  [EnumDepartment.SALES]: 'Vendas',
  [EnumDepartment.FINANCE]: 'Financeiro',
  [EnumDepartment.LEGAL]: 'Jurídico',
  [EnumDepartment.HR]: 'Recursos Humanos',
  [EnumDepartment.LOGISTICS]: 'Logística',
  [EnumDepartment.SUPPORT]: 'Atendimento',
  [EnumDepartment.POS_SALES]: 'Pós-venda',
  [EnumDepartment.TRAINING]: 'Treinamento',
  [EnumDepartment.IT]: 'TI / Desenvolvimento',
  [EnumDepartment.PROCUREMENT]: 'Compras',
  [EnumDepartment.MAINTENANCE]: 'Manutenção',
  [EnumDepartment.OPERATIONS]: 'Operações',
  [EnumDepartment.WAREHOUSE]: 'Almoxarifado',
  [EnumDepartment.OTHER]: 'Outro',
};


export enum EnumAssetCategory {
  // 🚗 FROTA E MOBILIDADE
  MOTORCYCLE = 'motorcycle',
  VEHICLE = 'vehicle',
  TRAILER = 'trailer',
  BICYCLE = 'bicycle',
  HELMET = 'helmet',
  GPS_TRACKER = 'gps_tracker',

  // 🖥️ TECNOLOGIA E INFRAESTRUTURA
  COMPUTER = 'computer',
  LAPTOP = 'laptop',
  MONITOR = 'monitor',
  PRINTER = 'printer',
  MODEM_ROUTER = 'modem_router',
  SERVER = 'server',
  SWITCH = 'switch',
  TELEPHONE = 'telephone',
  MOBILE_DEVICE = 'mobile_device',

  // 🪑 MOBILIÁRIO
  DESK = 'desk',
  CHAIR = 'chair',
  CABINET = 'cabinet',
  SHELF = 'shelf',
  SOFA = 'sofa',
  MEETING_TABLE = 'meeting_table',

  // 🏢 ESTRUTURA FÍSICA
  AIR_CONDITIONER = 'air_conditioner',
  TV = 'tv',
  FRIDGE = 'fridge',
  MICROWAVE = 'microwave',
  COFFEE_MACHINE = 'coffee_machine',
  WATER_COOLER = 'water_cooler',
  CAMERA_SECURITY = 'camera_security',
  LIGHTING = 'lighting',
  SOUND_EQUIPMENT = 'sound_equipment',
  FIRE_EXTINGUISHER = 'fire_extinguisher',
  SAFE = 'safe',

  // 🧰 MANUTENÇÃO & FERRAMENTAS
  TOOLBOX = 'toolbox',
  HYDRAULIC_JACK = 'hydraulic_jack',
  AIR_COMPRESSOR = 'air_compressor',
  BATTERY_CHARGER = 'battery_charger',
  WORKBENCH = 'workbench',
  OIL_DRAINER = 'oil_drainer',
  ELECTRIC_DRILL = 'electric_drill',
  MEASURING_EQUIPMENT = 'measuring_equipment',

  // 📦 ESTOQUE OPERACIONAL
  UNIFORMS = 'uniforms',
  SIGNAGE = 'signage',
  PROMOTIONAL_ITEMS = 'promotional_items',
  MAINTENANCE_PARTS = 'maintenance_parts',
  CLEANING_KIT = 'cleaning_kit',
  REPLACEMENT_HELMETS = 'replacement_helmets',

  // 🧑‍💼 SETOR ADMINISTRATIVO
  FILE_CABINET = 'file_cabinet',
  PROJECTOR = 'projector',
  SHREDDER = 'shredder',
  WHITEBOARD = 'whiteboard',
  CASH_REGISTER = 'cash_register',

  // 📢 MARKETING
  CAMERA = 'camera',
  LIGHT_KIT = 'light_kit',
  VIDEO_EQUIPMENT = 'video_equipment',
  AUDIO_INTERFACE = 'audio_interface',
  SOCIAL_MEDIA_SETUP = 'social_media_setup',
  LIVE_STREAM_KIT = 'live_stream_kit',

  // 🎓 SETOR DE TREINAMENTO (TEACH)
  SIMULATOR = 'simulator',
  TRAINING_KIT = 'training_kit',
  VR_GEAR = 'vr_gear',
  INSTRUCTIONAL_LAPTOP = 'instructional_laptop',

  // ☎️ PÓS-ATENDIMENTO / CENTRAL
  HEADSET = 'headset',
  CUSTOMER_SERVICE_DESK = 'customer_service_desk',
  CALL_CENTER_EQUIPMENT = 'call_center_equipment',
  RECORDING_SYSTEM = 'recording_system',

  // 🧾 FINANCEIRO / CONTÁBIL
  FISCAL_PRINTER = 'fiscal_printer',
  DOCUMENT_SCANNER = 'document_scanner',

  // 🛠️ OUTROS
  OTHER = 'other',
}

export const ASSET_CATEGORY_LABELS: Record<EnumAssetCategory, string> = {
  // 🚗 FROTA E MOBILIDADE
  [EnumAssetCategory.MOTORCYCLE]: 'Motocicleta',
  [EnumAssetCategory.VEHICLE]: 'Veículo',
  [EnumAssetCategory.TRAILER]: 'Reboque',
  [EnumAssetCategory.BICYCLE]: 'Bicicleta',
  [EnumAssetCategory.HELMET]: 'Capacete',
  [EnumAssetCategory.GPS_TRACKER]: 'Rastreador GPS',

  // 🖥️ TECNOLOGIA E INFRAESTRUTURA
  [EnumAssetCategory.COMPUTER]: 'Computador',
  [EnumAssetCategory.LAPTOP]: 'Notebook',
  [EnumAssetCategory.MONITOR]: 'Monitor',
  [EnumAssetCategory.PRINTER]: 'Impressora',
  [EnumAssetCategory.MODEM_ROUTER]: 'Modem/Router',
  [EnumAssetCategory.SERVER]: 'Servidor',
  [EnumAssetCategory.SWITCH]: 'Switch de rede',
  [EnumAssetCategory.TELEPHONE]: 'Telefone fixo',
  [EnumAssetCategory.MOBILE_DEVICE]: 'Dispositivo móvel',

  // 🪑 MOBILIÁRIO
  [EnumAssetCategory.DESK]: 'Mesa',
  [EnumAssetCategory.CHAIR]: 'Cadeira',
  [EnumAssetCategory.CABINET]: 'Armário',
  [EnumAssetCategory.SHELF]: 'Estante',
  [EnumAssetCategory.SOFA]: 'Sofá',
  [EnumAssetCategory.MEETING_TABLE]: 'Mesa de reunião',

  // 🏢 ESTRUTURA FÍSICA
  [EnumAssetCategory.AIR_CONDITIONER]: 'Ar-condicionado',
  [EnumAssetCategory.TV]: 'Televisão',
  [EnumAssetCategory.FRIDGE]: 'Geladeira',
  [EnumAssetCategory.MICROWAVE]: 'Micro-ondas',
  [EnumAssetCategory.COFFEE_MACHINE]: 'Cafeteira',
  [EnumAssetCategory.WATER_COOLER]: 'Bebedouro',
  [EnumAssetCategory.CAMERA_SECURITY]: 'Câmera de segurança',
  [EnumAssetCategory.LIGHTING]: 'Iluminação',
  [EnumAssetCategory.SOUND_EQUIPMENT]: 'Equipamento de som',
  [EnumAssetCategory.FIRE_EXTINGUISHER]: 'Extintor de incêndio',
  [EnumAssetCategory.SAFE]: 'Cofre',

  // 🧰 MANUTENÇÃO & FERRAMENTAS
  [EnumAssetCategory.TOOLBOX]: 'Caixa de ferramentas',
  [EnumAssetCategory.HYDRAULIC_JACK]: 'Macaco hidráulico',
  [EnumAssetCategory.AIR_COMPRESSOR]: 'Compressor de ar',
  [EnumAssetCategory.BATTERY_CHARGER]: 'Carregador de bateria',
  [EnumAssetCategory.WORKBENCH]: 'Bancada',
  [EnumAssetCategory.OIL_DRAINER]: 'Coletor de óleo',
  [EnumAssetCategory.ELECTRIC_DRILL]: 'Furadeira elétrica',
  [EnumAssetCategory.MEASURING_EQUIPMENT]: 'Equipamento de medição',

  // 📦 ESTOQUE OPERACIONAL
  [EnumAssetCategory.UNIFORMS]: 'Uniformes',
  [EnumAssetCategory.SIGNAGE]: 'Sinalização',
  [EnumAssetCategory.PROMOTIONAL_ITEMS]: 'Brindes promocionais',
  [EnumAssetCategory.MAINTENANCE_PARTS]: 'Peças de manutenção',
  [EnumAssetCategory.CLEANING_KIT]: 'Kit de limpeza',
  [EnumAssetCategory.REPLACEMENT_HELMETS]: 'Capacetes reserva',

  // 🧑‍💼 SETOR ADMINISTRATIVO
  [EnumAssetCategory.FILE_CABINET]: 'Arquivo',
  [EnumAssetCategory.PROJECTOR]: 'Projetor',
  [EnumAssetCategory.SHREDDER]: 'Fragmentadora',
  [EnumAssetCategory.WHITEBOARD]: 'Quadro branco',
  [EnumAssetCategory.CASH_REGISTER]: 'Caixa registradora',

  // 📢 MARKETING
  [EnumAssetCategory.CAMERA]: 'Câmera (Marketing)',
  [EnumAssetCategory.LIGHT_KIT]: 'Kit de iluminação',
  [EnumAssetCategory.VIDEO_EQUIPMENT]: 'Equipamento de vídeo',
  [EnumAssetCategory.AUDIO_INTERFACE]: 'Interface de áudio',
  [EnumAssetCategory.SOCIAL_MEDIA_SETUP]: 'Equipamento de mídias sociais',
  [EnumAssetCategory.LIVE_STREAM_KIT]: 'Kit de live stream',

  // 🎓 SETOR DE TREINAMENTO
  [EnumAssetCategory.SIMULATOR]: 'Simulador',
  [EnumAssetCategory.TRAINING_KIT]: 'Kit de treinamento',
  [EnumAssetCategory.VR_GEAR]: 'Equipamento de realidade virtual',
  [EnumAssetCategory.INSTRUCTIONAL_LAPTOP]: 'Notebook de instrução',

  // ☎️ CENTRAL / PÓS-ATENDIMENTO
  [EnumAssetCategory.HEADSET]: 'Headset',
  [EnumAssetCategory.CUSTOMER_SERVICE_DESK]: 'Estação de atendimento',
  [EnumAssetCategory.CALL_CENTER_EQUIPMENT]: 'Equipamento de call center',
  [EnumAssetCategory.RECORDING_SYSTEM]: 'Sistema de gravação',

  // 🧾 FINANCEIRO
  [EnumAssetCategory.FISCAL_PRINTER]: 'Impressora fiscal',
  [EnumAssetCategory.DOCUMENT_SCANNER]: 'Scanner de documentos',

  // 🛠️ OUTROS
  [EnumAssetCategory.OTHER]: 'Outro',
};

export enum EnumAssetStatus {
  ACTIVE = 'active', // Em uso
  DISPOSED = 'disposed', // Baixado/descartado
  TRANSFERRED = 'transferred', // Transferido entre locais
  UNDER_MAINTENANCE = 'under_maintenance', // Em manutenção
}

export enum EnumDocumentStatus {
  GENERATED = 'generated', 
  SIGNED = 'signed', 
}

export const ASSET_STATUS_LABELS: Record<EnumAssetStatus, string> = {
  [EnumAssetStatus.ACTIVE]: 'Em uso',
  [EnumAssetStatus.DISPOSED]: 'Baixado/descartado',
  [EnumAssetStatus.TRANSFERRED]: 'Transferido',
  [EnumAssetStatus.UNDER_MAINTENANCE]: 'Em manutenção',
};

export enum EnumTaxRegime {
  LUCRO_REAL = 'lucro_real',
  LUCRO_PRESUMIDO = 'lucro_presumido',
  SIMPLES_NACIONAL = 'simples_nacional',
  MEI = 'mei',
  UNKNOWN = 'unknown',
}

export const TAX_REGIME_LABELS: Record<EnumTaxRegime, string> = {
  [EnumTaxRegime.LUCRO_REAL]: 'Lucro Real',
  [EnumTaxRegime.LUCRO_PRESUMIDO]: 'Lucro Presumido',
  [EnumTaxRegime.SIMPLES_NACIONAL]: 'Simples Nacional',
  [EnumTaxRegime.MEI]: 'MEI',
  [EnumTaxRegime.UNKNOWN]: 'Desconhecido',
};

export interface IinventoryManagement {
  _id: string; // Identificador único do ativo imobilizado
  assetCode?: string; // Código patrimonial do bem (ex: "BEM-001")
  description?: string; // Descrição do bem (ex: "Notebook Dell Latitude")
  category?: EnumAssetCategory; // Categoria contábil (ex: informática, veículos, móveis)
  companyId?: string; // ID da empresa proprietária do bem
  serieNumber?: string;

  departmentEnum?: EnumDepartment; // Departamento responsável (relacionamento organizacional)

  acquisitionDate?: Date; // Data em que o bem foi adquirido
  acquisitionValue?: number; // Valor de compra (valor bruto)
  residualValue?: number; // Valor residual estimado no fim da vida útil
  depreciationRate?: number; // Percentual anual de depreciação (ex: 10%)
  netValue?: number; // Valor contábil líquido (pode ser calculado ou armazenado)
  usefulLifeInMonths?: number; // Vida útil do bem em meses
  currentStatus?: EnumAssetStatus; // Estado atual do ativo

  fiscalIncentive?: boolean; // Indica se o ativo possui incentivo fiscal
  icmsCreditable?: boolean; // Gera crédito de ICMS?
  pisCofinsRate?: number; // Alíquota de PIS/COFINS aplicável (se houver)
  taxRegime?: EnumTaxRegime; // Regime tributário da empresa no momento da aquisição

  invoiceKey?: string; // Chave da nota fiscal (44 dígitos, obrigatória para validação fiscal) 
  invoiceDocumentPath?: string; // Documento da nota fiscal (pode ser o XML ou PDF)

  lastInventoryDate?: Date; // Última data em que o bem foi inventariado
  physicalTagPresent?: boolean; // Informa se a etiqueta patrimonial está visível/física

  notes?: string; // Observações adicionais sobre o ativo

  createdAt?: Date; // Data de criação do registro
  updatedAt?: Date; // Data da última atualização do registro
  deleteAt?: Date; // Data de exclusão lógica (se houver)
  createdBy: string; // ID do usuário que criou o ativo

  employeerId?: string;
  documentStatus?: string;
  signedDocumentPath?: string;
}
